const grindSelect = document.querySelector('#grind-select');

if (grindSelect) {
  grindSelect.addEventListener('change', (e) => {
    const correspondingParent = grindSelect.closest('.product');
    const correspondingElement = correspondingParent.querySelector(`input[value="${e.target.value}"]`);
    correspondingElement.click();
  })
}